(() => {
  const titleSelector = [
    '#MainContent h1',
    '#MainContent .section__heading',
    '#MainContent .sf__section-heading',
    '#MainContent .content__heading',
    '#MainContent .nd-project__text h2',
    '#MainContent .nd-project__materials h2',
    '#MainContent .nd-about__chapter h2',
    '#MainContent .nd-card__content h2',
    '#MainContent .nd-project__cta-title'
  ].join(',');

  const imageSelector = [
    '#MainContent .home-banner__slideshow .sf__slide-media',
    '#MainContent .sf__pcard-image',
    '#MainContent .image__box',
    '#MainContent .nd-card__media',
    '#MainContent .nd-project__hero',
    '#MainContent .nd-project__image',
    '#MainContent .nd-about__portrait',
    '#MainContent .sf-prod-media-item',
    '#MainContent .collection-header__image',
    '#MainContent .ecom-core .ecom-base-image'
  ].join(',');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = (element) => element.classList.add('nd-reveal--visible');
  const observer = !reduceMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 })
    : null;

  const prepare = (elements, type) => {
    elements.forEach((element, index) => {
      if (element.hasAttribute('data-nd-reveal')) return;
      if (element.closest('[hidden], .quick-view, #cart-drawer-container')) return;

      element.setAttribute('data-nd-reveal', type);
      element.style.setProperty('--nd-reveal-delay', `${Math.min(index % 4, 3) * 60}ms`);

      if (observer) observer.observe(element);
      else reveal(element);
    });
  };

  const initialize = (root = document) => {
    prepare(root.querySelectorAll(titleSelector), 'title');
    prepare(root.querySelectorAll(imageSelector), 'image');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
